import React from "react";

export function BadgePill({ bgColor, color, text }) {
  const badgeClass = () => {
    switch (bgColor) {
      default:
        return null;

      case "crimson":
        return "#DC143C";

        case "darkred":
        return "#8B0000";

      case "orangered":
        return "#FF4500";

      case "red":
        return "#FF0000";

      case "orange":
        return "#ffc107";

      case "yellow":
        return "#FFFF00";

      case "green":
        return "#17b72a";

      case "blue":
        return "#000f9f";

      case "light-blue":
        return "#007bff";
    }
  };
  return (
    <div
      className="badge badge-pill font-thai-b"
      style={{
        backgroundColor: badgeClass() || bgColor || "#999999",
        color: color || "#ffffff",
        marginRight: "10px",
      }}
    >
      <span className="text-center fs-16">{text}</span>
    </div>
  );
}
